import { DocumentCitizenshipFilterForm } from 'civil-status/view-models/document-citizenship-list';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesDocumentCitizenshipSearch: DocumentCitizenshipFilterForm = {
  page: 0,
  rowsPerPage: 10,
  orders: {},
  year: '',
  document: '',
  registry: null,
  portion: '',
  serie: '',
  matricola: '',
  surname: '',
  name: '',
  operationYear: '0',
  operationDocument: '0',
  operationRegistry: '0',
  operationPortion: '0',
  operationSerie: '0',
  operationMatricola: '0',
  operationSurname: '0',
  operationName: '0',
};

const PageDocumentCitizenshipSearchInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesDocumentCitizenshipSearch}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageDocumentCitizenshipSearchInitializer.displayName =
  'Page search citizenship initializer component';

export default PageDocumentCitizenshipSearchInitializer;
